import { render, staticRenderFns } from "./VbgHealthCheck.vue?vue&type=template&id=0776e814&scoped=true"
import script from "./VbgHealthCheck.vue?vue&type=script&lang=js"
export * from "./VbgHealthCheck.vue?vue&type=script&lang=js"
import style0 from "./VbgHealthCheck.vue?vue&type=style&index=0&id=0776e814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0776e814",
  null
  
)

export default component.exports